<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb
            class="row justify-content-center mt-4"
          />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-0 border-bottom">
      <v-col>
                  <!-- <DateRange></DateRange> -->
                  <newFiltercomp :filter_data="param"/>
      </v-col>
    </v-row>
    <!-- <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :items-per-page="5"
      class="elevation-1"
      @pagination="pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                outlined
                fab
                small
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>icon-download</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <vue-json-to-csv
                      :json-data="dataDownload"
                      :csv-title="'Audit Log Report Data'"
                    >
                      <v-btn color="indigo" dark style="">
                        CSV
                      </v-btn>
                    </vue-json-to-csv>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-btn @click="createPDF" color="indigo" dark>PDF </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>
      </template>
    </v-data-table> -->
    <div>
      <tableComponent v-bind:tabledataProp="TableData" v-if="show"/>
    </div>
  </v-container>
</template>

<script>
import newFiltercomp from "../components/newFiltercomp.vue";
import tableComponent from '../components/tableComponent.vue';
import Breadcrumb from "../components/breadcrumbs.vue";
import axios from "axios";
// import VueJsonToCsv from "vue-json-to-csv";
// import constants from "../constants";
import router from "../router";
// import jsPDF from "jspdf";
import "jspdf-autotable";
// const logo = require("../assets/trinitiimage.png");
export default {
  name: "AuditLogReport",
  components: {
    
    newFiltercomp,
    Breadcrumb,
    tableComponent 
  },
  data() {
    return {
      param : {
        userSelected_Id: null,
        machine : false,
        time_period: true,
        check : false,
        aggfunc : false,
        date :new Date().toISOString().slice(0,10),
        date_2 :new Date().toISOString().slice(0,10),
        redirectStartDate : null,
        redirectEndDate : null,
        redirectPath : null,
        machine_id: null,
        // redirectStartTime:null,
        // redirectEndTime:null
        grpshw: null,
        dateFunc: null,
        checkbox: null,
        
      },
      show:false,
    
      TableData:{
      savingFilename:'Audit Log Report',
      // Post-process downloaded PDF: shift content by pdfExtraSpace points
      // (negative crops the bottom), then fit each page onto A4 portrait.
      pdfFitA4Portrait: true,
      pdfExtraSpace: -15,

      headersData: [],
      operatorsData: [],
      search: "",
      menu: false,
      dataDownload: [],
      showWarning: false,
      showLoader: false,
      columnHeaders 
      :[
      "Customer Name",
        "User",
        "Creation Date",
        "Login Time",
        "Login Unix Time",
        "Logout Time",
        "Logout Unix Time",
        "Session Time",
        "Status",
        "Ipaddress",
        "Audit",
        "Logout Intent"
      ],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
      tempRow :[
         "customer_name" ,
          "user_name" ,
          "creation_date",
          "login_ts",
          "login_unix_ts" ,
          "logout_ts" ,
          "logout_unix_ts" ,
          "session_time" ,
          "status",
          "ipaddress" ,
          "audit",
          "Logout_Intent"
      ],
      },
      items: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
        {
          text: "Report Menu",
          disabled: true,
          href: "/",
        },
        {
          text: "Audit Log Report",
          disabled: true,
        },
      ],
      
    };
  },
  mounted() {},
  methods: {
   
//     createPDF() {
//       let content = this.$refs["theDataTable"];
//       console.log("pagination", this.pagination);
//       let doc = new jsPDF("landscape");
//       doc.text(14, 7.5, "Audit Log Report");
//  doc.addImage(
//         this.getImgUrl1(this.$config.image_inside_pdf),
//         "png",
//         this.$config.first_dimension_separate_again,
//         this.$config.second_dimension_separate,
//         this.$config.third_dimension_separate,
//         this.$config.fourth_dimension_separate_again
//       );      let columnHeaders = [
//         "Customer Name",
//         "User",
//         "Login Time",
//         "Login Unix Time",
//         "Logout Time",
//         "Logout Unix Time",
//         "Session Time",
//         "Status",
//         "Ipaddress",
//       ];
//       let rows = [];
//       content.items.forEach((data, index) => {
//         if (
//           index >= this.pagination.pageStart &&
//           index < this.pagination.pageStop
//         ) {
//           let tempRow = [
//             data.customer_name || "",
//             data.user_name || "",
//             data.login_ts || "",
//             data.login_unix_ts || "",
//             data.logout_ts || "",
//             data.logout_unix_ts || "",
//             data.session_time || "",
//             data.status || "",
//             data.ipaddress || "",
//           ];
//           rows.push(tempRow);
//         }
//       });
//       console.log("checkign temp row=>", rows);
//       doc.setFontSize(9);
//       doc.autoTable(columnHeaders, rows, { startY: 11.5 });
//       let d = new Date();
//       doc.save(
//         `Audit_Log_report ${d.toISOString().slice(0, 10) +
//           " " +
//           d
//             .toTimeString()
//             .split("(")[0]
//             .slice(0, -1)}.pdf`
//       );
//     },

    intervalFetchData: function(machine_id, startDate, endDate,grpshw,
      dateFunc,
      checkbox,
      userSelected_Id) {
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      this.grpshw = grpshw;
      this.dateFunc = dateFunc;
      this.checkbox = checkbox;
      this.userSelected_Id = userSelected_Id;
      console.log("machine_id", machine_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );
      console.log("checking sessionStorage==", sessionStorage);
      this.searchNew(this.machine_id_Selected, startDate, endDate, this.userSelected_Id);
    },
    searchNew: function(machine_id, startDate, endDate, userSelected_Id) {
      this.show = false
      this.userSelected_Id = userSelected_Id;
      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;
      let params = "";
      if (this.start_date == "") {
        params = ``;
      } else {
        params = `?user_id=${this.userSelected_Id}&startdate=${this.start_date}&enddate=${this.end_date}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/audit${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.setGridData(config);
    },
    setGridData: function(config) {
      this.headersData = [
        {
          text: "Customer Name",
          value: "customer_name",
          sortable: true,
        },
        {
          text: "User",
          value: "user_name",
          sortable: true,
        },
        {
          text: "Creation Date",
          value: "creation_date",
          sortable: true,
        },
        
        {
          text: "Login Time",
          value: "login_ts",
          sortable: true,
        },

        {
          text: "Login Unix Time",
          value: "login_unix_ts",
          sortable: true,
        },

        {
          text: "Logout Time",
          value: "logout_ts",
          sortable: true,
        },
        {
          text: "Logout Unix Time",
          value: "logout_unix_ts",
          sortable: true,
        },
        {
          text: "Session Time (Seconds)",
          value: "session_time",
          sortable: true,
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
        },

        {
          text: "Ipaddress",
          value: "ipaddress",
          sortable: true,
        },
        {
          text: "Audit",
          value: "audit",
          sortable: true,
        },
        {
          text: "Logout Intent",
          value: "Logout_Intent",
          sortable: true,
        },
      ];
      this.TableData['headersData']=this.headersData

      this.showLoader = true;
      this.showWarning = false;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          let _data = response.data.data;
          console.log("checkign resp", response.data.data);
          this.operatorsData = response.data.data;
          this.TableData['operatorsData']=this.operatorsData
          let result = [];
          for (let i in response.data) result.push([i, response.data[i]]);
          this.dataDownload = result[0][1];
          this.TableData['dataDownload']=this.dataDownload
          console.log("download pdf", this.dataDownload);
          this.item = _data;
          this.showLoader = false;
          this.show = true
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            this.showWarning = true;
            this.item = [];
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
